import { Component, OnInit, OnDestroy, ViewChild, Inject, PLATFORM_ID, ElementRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../shared/services/apiService.service';
import { RootService } from '../shared/services/root.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { SkeletonService } from '../shared/services/skeleton.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { CanonicalService } from '../shared/seo/canonical.service';
declare var $;
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { BreadcrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';

import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { SeoService } from 'src/app/shared/seo/seo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-explore-page',
  templateUrl: './explore-page.component.html',
  styleUrls: ['./explore-page.component.scss'],
})
export class ExplorePageComponent implements OnInit, OnDestroy {
  @ViewChild(BreadcrumbComponent) breadCrumb: BreadcrumbComponent;
  @ViewChild('cardElement') cardElement: ElementRef;
  environment1 = environment.s3bucket.url;

  heartUrls = {
    empty: "assets/images/Star-unfilled.svg",
    half: "assets/images/Star-unfilled.svg",
    full: "assets/images/Star-filled.svg"
  };
  banners: any;
  isLoading: boolean = false;
  centerBanners: any = [];
  lob: any;
  sub: Subscription = new Subscription();
  browseByModel: any = [];
  mainBrowseByModel: any = [];
  sub_lob: any;
  popularVehicleList: any = [];
  explore: string;
  productList: any;
  bannerLOB: string;
  showStaticBanner: any;
  browseByTypeLoad: boolean = false;
  browseByModelLoad: boolean = false;
  popularVehicleListLoad: boolean = false;
  isExplore: boolean = false;
  isUserLoggedIn: any;
  userData: any;
  showBreadCrumb: boolean = true;
  breadcrumbdata: any = [];
  modifiedExploreData: any = [];
  modifiedBrowseBylob: any = [];
  modifiedBrowseByModal: any = [];
  modifiedBrowseByType: any = [];
  modifiedExploreByType: any = [];
  seoValue: string;
  headerData: any = [];
  promovideosLoaded: boolean = false;
  testSafeUrl!: SafeResourceUrl;
  promotionalVideos: any = [];
  showLoader: any = false;
  productLoaded: boolean = false;
  brandVideoSize: any = 0;
  videoTotalCount: any = 0;
  videoData: any = [];
  exploredata: any = [];
  categorylisticons: any;
  ismobile: boolean = false;
  exploreVehicleRangeList: any[];
  newexploreVehicleRangeRESPList: any[];
  vehicleType: string;
  pplValue: any;
  uniqueExploreByBrandList: any[];
  uniqueExploreBytype: any[];
  uniqueExploreByppl: any[];
  imagestype: any[];
  height: number=0;
  width: number=0;
  isMobile: boolean;
  constructor(
    private apiService: ApiService,
    private toastrService: ToastrService,
    public skeletonService: SkeletonService,
    private activatedRoute: ActivatedRoute,
    private WishlistService: WishlistService,
    private router: Router,
    private rootService: RootService,
    private spinner: NgxSpinnerService,
    private behaviorService: BehaviourSubjectService,
    private canonicalservice: CanonicalService,
    private localStorage: secureStorage,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cleverService: ClevertapService,
    private sanitizer: DomSanitizer,
    private seoservice: SeoService
  ) {}

  ngOnInit(): void {
    this.detectmob();
    if (isPlatformBrowser(this.platformId)) {
      this.height = window.innerHeight;
      this.width = window.innerWidth
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

    }
    this.canonicalservice.createCanonicalURL('');
    if (isPlatformBrowser(this.platformId)) {
      $('.header').addClass('p-scroll');

      localStorage.removeItem('sideFilter');
      localStorage.removeItem('ExploreMappedData');
      localStorage.removeItem('ExploreMappedData1');

      localStorage.removeItem('exploreData');
      localStorage.removeItem('UrlData');
      localStorage.removeItem('explore');
      localStorage.removeItem('EModeldData');
    }
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get('lob')) {
        this.seoValue = params.get('lob').replace('-', ' ');
        this.seo(this.seoValue);
      }

      this.lob = params.get('lob');
      this.explore = params.get('explore');
      this.localStorage.setItem('explore', JSON.stringify(this.explore));
      this.getexplorePage();
      this.getPromotionalVideoData(10);
      this.categorylisticons = params.get('category-list');
      if (this.explore) {
        this.seoValue = params.get('explore').replace('-', ' ');
        this.seo(this.seoValue);
        this.isExplore = true;
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('localBreadCrumb');
        }
        this.breadcrumbdata = [];
        let breadcrumbList: any = [];
        breadcrumbList = {
          label: this.explore.replace('-', ' '),
          url: '',
        };
        this.breadcrumbdata.push(breadcrumbList);
        if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem(
            'localBreadCrumb',
            JSON.stringify(this.breadcrumbdata)
          );
        }
        this.breadCrumb?.getBreadCrumb();
        this.showBreadCrumb = true;
        this.explorePageBanners();
        setTimeout(() => {
          this.getPopularVehicle('explore', this.explore);
        }, 1000);
      } else {
        if (params.get('sub_lob') == 'trucks') {
          this.sub_lob = 'trucks';
        } else if (params.get('sub_lob') == 'buses-vans') {
          this.sub_lob = 'buses';
        } else if (params.get('sub_lob') == 'scv-pickups') {
          this.sub_lob = 'SCVPickups';
        }
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('localBreadCrumb');
        }
        this.breadcrumbdata = [];
        let breadcrumbList: any;
        breadcrumbList = {
          label:
            this.sub_lob == 'buses'
              ? 'buses & vans'
              : this.sub_lob == 'SCVPickups'
              ? 'scv pickups'
              : this.sub_lob,
          url: '',
        };
        this.breadcrumbdata.push(breadcrumbList);
        breadcrumbList = {
          label: this.lob?.replace('-', ' '),
          url: '',
        };
        this.breadcrumbdata.push(breadcrumbList);
        if (isPlatformBrowser(this.platformId)) {
          this.localStorage.setItem(
            'localBreadCrumb',
            JSON.stringify(this.breadcrumbdata)
          );
        }
        this.breadCrumb?.getBreadCrumb();
        this.showBreadCrumb = true;
        this.getBannersNew();

        this.getVehicleExploreData(this.lob, '');
        this.getPopularVehicle('lob', '');
      }
      this.categorylisticons = localStorage.getItem('categoryIcons');

      // this.getPromotionalVideoData(10);
    });
    this.sub.add(
      this.behaviorService.isLoggedIn.subscribe(() => {
        this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
        this.userData = this.rootService.getUserData();
      })
    );
  }
  detectmob() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth <= 800 && window.innerHeight <= 600) {
        this.ismobile = true;
      } else {
        this.ismobile = false;
      }
    }
  }

  pplList: any = [];

  customOptions1: OwlOptions = {
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src=${this.environment1}assets/images/c-arrow-left.svg>`,
      `<img alt="right" src=${this.environment1}assets/images/c-arrow-right.svg>`,
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
    nav: true,
  };

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    responsiveRefreshRate: 1000000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      740: {
        items: 1,
      },
      940: {
        items: 1,
      },
    },
  };
  getBannersNew() {
    try {
      let req = {
        page: 'EXPLORE',
        offset: 0,
        size: 3,
        lob: [this.lob],
      };
      this.sub.add(
        this.apiService.getBannerListNew(req).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.spinner.hide();
              this.isLoading = true;
              this.centerBanners = response;
            } else {
              this.spinner.hide();
              this.centerBanners = [];
              this.isLoading = false;
              if (response?.data?.msg == 'User is not registered.') {
                this.toastrService.warning(response.data.msg || response.msg);
              } else {
                this.centerBanners = [];
                this.isLoading = false;
                this.spinner.hide();
              }
            }
          },
          error: () => {
            this.isLoading = false;
            this.toastrService.warning('Something went wrong!');
            this.spinner.hide();
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  GetTest(data: any) {
    let url;
    var dataUrl = data.banner_link;
    if (dataUrl) {
      if (isPlatformBrowser(this.platformId)) {
        url = dataUrl?.replace(window.location.origin + '/' + dataUrl);
        this.router.navigateByUrl(url);
      }
    }
  }

  explorePageBanners() {
    try {
      this.spinner.show();
      this.sub.add(
        this.apiService.getS3Data('productList.txt').subscribe({
          next: (response) => {
            this.spinner.hide();
            this.productList = response.data.ModeList;
          },
          error: () => {
            this.spinner.hide();
          },
          complete: () => {
            this.spinner.hide();
            if (this.explore) {
              if (
                this.explore == 'heavy-trucks' ||
                this.explore == 'tippers' ||
                this.explore == 'light-trucks' ||
                this.explore == 'tractor-trailer' ||
                this.explore == 'trucks' ||
                this.explore == 'heavy-truck' ||
                this.explore == 'icv-trucks' ||
                this.explore == 'tractor-trailer' ||
                this.explore == 'tipper' ||
                this.explore == 'light-truck' ||
                this.explore == '6-wheeler-truck' ||
                this.explore == 'distribution-truck'
              ) {
                this.bannerLOB =
                  this.explore == 'trucks'
                    ? this.activatedRoute.snapshot.paramMap.get('sub_lob')
                    : this.explore;
                this.sub_lob = 'trucks';

                setTimeout(() => {
                  let data = this.productList?.find(
                    (e) => e.seo_name == this.explore
                  );

                  this.getModels(data);
                  this.getVehicleExploreData('', data);
                }, 1000);
              }
              if (
                this.explore == 'mini-trucks-&-pickups' ||
                this.explore == 'scv-pickups' ||
                this.explore == 'large-pickup' ||
                this.explore == 'mini-truck' ||
                this.explore == 'small-pickup'
              ) {
                this.bannerLOB =
                  this.explore == 'scv-pickups'
                    ? this.activatedRoute.snapshot.paramMap.get('sub_lob')
                    : this.explore;
                this.sub_lob = 'SCVPickups';

                setTimeout(() => {
                  let data = this.productList?.find(
                    (e) => e.seo_name == this.explore
                  );

                  this.getVehicleExploreData('', data);
                  this.getModels(data);
                }, 1000);
              }
              if (
                this.explore == 'bus' ||
                this.explore == 'vans' ||
                this.explore == 'buses-vans' ||
                this.explore == 'passenger-van' ||
                this.explore == 'school-van' ||
                this.explore == 'ambulance' ||
                this.explore == 'school-bus' ||
                this.explore == 'staff-bus' ||
                this.explore == 'bus-chassis' ||
                this.explore == 'intercity-bus'
              ) {
                this.bannerLOB =
                  this.explore == 'buses-vans'
                    ? this.activatedRoute.snapshot.paramMap.get('sub_lob')
                    : this.explore;
                this.sub_lob = 'buses';

                setTimeout(() => {
                  let data = this.productList?.find(
                    (e) => e.seo_name == this.explore
                  );

                  this.getVehicleExploreData('', data);
                  this.getModels(data);
                }, 1000);
              }

              this.exploreBanner();
            }
          },
        })
      );
    } catch (error) {}
  }

  getModels(data: any) {
    try {
      this.browseByModel = [];
      let ppl_list: any = [];
      this.headerData.forEach((el) => {
        el.ppl_list.forEach((ppl) => ppl_list.push(ppl));
      });
      let req = {
        ppl_list: data.ppl_list,
        el_pl_list: data.el_pl_list,
        vc_number_s: data.vc_number_s,
      };
      this.sub.add(
        this.apiService.getDashboardLobwise(req).subscribe({
          next: (response: any) => {
            let keys = Object.keys(response.data);
            this.lob = response.data[keys[0]][0]?.lob
              ?.replace(/\s/g, '-')
              ?.toLowerCase();
            if (!this.isExplore) {
              keys.forEach((key) => {
                ppl_list.forEach((ppl) => {
                  if (ppl.actual_ppl == key) {
                    this.browseByModel.push(ppl);
                  }
                });
              });
            }
            this.browseByModelLoad = true;
          },
          error: () => {
            this.browseByModelLoad = true;
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  onClickArrowModel(data: any) {
    let datanew;
    if (
      this.explore == 'heavy-trucks' ||
      this.explore == 'tippers' ||
      this.explore == 'light-trucks' ||
      this.explore == 'tractor-trailer' ||
      this.explore == 'trucks' ||
      this.explore == 'heavy-truck' ||
      this.explore == 'icv-trucks' ||
      this.explore == 'tractor-trailer' ||
      this.explore == 'tipper' ||
      this.explore == 'light-truck' ||
      this.explore == '6-wheeler-truck' ||
      this.explore == 'distribution-truck' ||
      this.explore == 'mini-trucks-&-pickups' ||
      this.explore == 'scv-pickups' ||
      this.explore == 'large-pickup' ||
      this.explore == 'mini-truck' ||
      this.explore == 'small-pickup' ||
      this.explore == 'bus' ||
      this.explore == 'vans' ||
      this.explore == 'buses-vans' ||
      this.explore == 'passenger-van' ||
      this.explore == 'school-van' ||
      this.explore == 'ambulance' ||
      this.explore == 'school-bus' ||
      this.explore == 'staff-bus' ||
      this.explore == 'bus-chassis' ||
      this.explore == 'intercity-bus'
    ) {
      if (this.modifiedBrowseByModal?.length > 0) {
        let a = this.modifiedBrowseByModal.filter((e: any) => {
          return e.ppl == data.ppl;
        });
        datanew = a[0].lob.replace(/\s/g, '-')?.toLowerCase();
        let vcNumbers = a;
        if (isPlatformBrowser(this.platformId)) {
          localStorage.removeItem('ExploreMappedData');
          localStorage.removeItem('explore');
          this.localStorage.setItem(
            'ExploreMappedDatamodal',
            JSON.stringify(data)
          );
          this.localStorage.setItem(
            'ExploreMappedData1',
            JSON.stringify(vcNumbers)
          );
        }
      } else {
        datanew = this.lob;
      }
    } else {
      datanew = this.lob;
    }
      this.behaviorService.callPlp.next(false)
      let queryParams:any = {
        "isSearch":true
      }
      localStorage.removeItem('totalNoOfRecords')
      localStorage.removeItem('uniqueId')
      localStorage.removeItem('searchValue')
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
    let sub_lob = (this.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.sub_lob.replace(/\s/g, "-").toLowerCase()) == 'buses' ? 'buses-vans' : this.sub_lob.replace(/\s/g, "-").toLowerCase() == 'scvpickups' ? 'scv-pickups' : this.sub_lob.replace(/\s/g, "-").toLowerCase())
    this.router.navigate(['/product-list/' + sub_lob + '/' + datanew
      + '/' + (data.ppl.replace(/\s/g, "-").replace(/\//g, "-").replace("---", "-"))?.toLowerCase()],{ queryParams });
  }

  onClickExplore(data: any, breadcrumb?: any) {
    let queryParams:any = {
      "isSearch":true
    }
    localStorage.removeItem('totalNoOfRecords')
      localStorage.removeItem('uniqueId')
      localStorage.removeItem('searchValue')
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
    if (this.isExplore) {
      let sub_lob = this.sub_lob.replace(/\s/g, "-")?.toLowerCase()
      let lob = data.lob.replace(/\s/g, "-").replace(/\---/g, '-').replace(/\--/g, '-')?.toLowerCase()
      let ppl = data.ppl.replace(/\s/g, "-").replace(/\---/g, '-').replace(/\--/g, '-')?.toLowerCase()
      this.router.navigate(['/product-list/' + sub_lob + '/' + lob + '/' + ppl],{ queryParams });
    } else {
      let ppl_name = this.pplList?.map(e => e?.replace(/\s/g, "-")?.replace(/\---/g, '-')?.replace(/\--/g, '-')?.replace(/&/g, 'AND')?.toLowerCase())
      ppl_name = ppl_name.join('&')
      this.router.navigate(['product-list'], { queryParams: { "ppl": ppl_name, "cabintype": breadcrumb ? data.Title : data.title_ppl ,"isSearch":true} });
    }
  }

  getPopularVehicle(val: any, dataType: any) {
    let data: any;
    if (val == 'lob') {
      data = {
        start_row: 0,
        end_row: 8,
        is_popular: true,
        actual_lob_name: [this.lob],
      };
      try {
        this.sub.add(
          this.apiService.getVehicleInfo2(data).subscribe(
            (res) => {
              this.popularVehicleListLoad = true;
              if (res.success) {
                this.popularVehicleList = res.data.slice(0, 8);
                if (!this.rootService.getUserData()) {
                  let wishList: any = [];
                  wishList = this.WishlistService.getWishlist();
                  if (wishList?.length > 0) {
                    wishList.forEach((el: any) => {
                      for (let i = 0; i < this.popularVehicleList?.length; i++) {
                        if (el == this.popularVehicleList[i].id) {
                          this.popularVehicleList[i].wishlist = true;
                        }
                      }
                    });
                  }
                }
              } else {
                this.popularVehicleList = [];
                this.popularVehicleListLoad = true;
              }
            },
            () => {
              this.popularVehicleListLoad = true;
            }
          )
        );
      } catch (error) {
        this.popularVehicleListLoad = true;
      }
    } else if (val == 'explore') {
      let filteredName: any = this.productList?.find(
        (value: any) => dataType == value.seo_name
      );
      data = {
        start_row: 0,
        end_row: 8,
        is_popular: true,
        ppl_name: filteredName?.ppl_seo_list,
      };
      try {
        this.sub.add(
          this.apiService.getVehicleInfo2(data).subscribe(
            (res) => {
              this.popularVehicleListLoad = true;
              if (res.success) {
                this.popularVehicleList = res.data.slice(0, 8);
                if (!this.rootService.getUserData()) {
                  let wishList: any = [];
                  wishList = this.WishlistService.getWishlist();
                  if (wishList?.length > 0) {
                    wishList.forEach((el: any) => {
                      for (let i = 0; i < this.popularVehicleList?.length; i++) {
                        if (el == this.popularVehicleList[i].id) {
                          this.popularVehicleList[i].wishlist = true;
                        }
                      }
                    });
                  }
                }
              } else {
                this.popularVehicleList = [];
                this.popularVehicleListLoad = true;
              }
            },
            () => {
              this.popularVehicleListLoad = true;
            }
          )
        );
      } catch (error) {
        this.popularVehicleListLoad = true;
      }
    }
  }

  clickToAddWishlist(event: any) {
    if (this.rootService.getUserData()) {
      let index: any;
      for (let e = 0; e < this.popularVehicleList?.length; e++) {
        if (this.popularVehicleList[e].id == event) {
          index = this.popularVehicleList.findIndex((e: any) => e.id == event);
        }
      }
      if (this.popularVehicleList[index].id == event) {
        if (this.popularVehicleList[index].wishlist == false) {
          this.popularVehicleList[index].wishlist = true;
          this.addToWishlist(event, 'add');
          return;
        }
        if (this.popularVehicleList[index].wishlist == true) {
          this.popularVehicleList[index].wishlist = false;
          this.addToWishlist(event, 'delete');
          return;
        }
      }
    } else {
      this.popularVehicleList?.forEach((e: any) => {
        if (e.id == event) e.wishlist = !e.wishlist;
      });
      this.WishlistService.addItemToWishList(event);
      let wishList: any = [];
      wishList = this.WishlistService.getWishlist();
      wishList?.forEach((el: any) => {
        for (let i = 0; i < this.popularVehicleList?.length; i++) {
          if (el == this.popularVehicleList[i].id) {
            this.popularVehicleList.wishlist = true;
          } else {
            this.popularVehicleList.wishlist = false;
          }
        }
      });
    }
  }

  addToWishlist(event: any, type: any) {
    let data;
    if (type == 'add') {
      data = {
        product: [event],
      };
    } else {
      data = {
        action_type: 'delete',
        product_list: [event],
      };
    }
    try {
      this.sub.add(
        this.apiService.addToWishlist(data).subscribe({
          next: (res: any) => {
            if (type == 'add') {
              this.toastrService.success(res.data.msg);
              this.popularVehicleList.forEach((e: any) => {
                if (e.id == event) {
                  e.wishlist = true;
                  return;
                }
              });
            } else {
              this.toastrService.warning(res.data.msg);
            }
          },
          error: () => {},
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  openProduct(data: any) {
    let sublob = (
      data.sub_lob == 'SCV Pickups'
        ? 'scv-pickups'
        : data.sub_lob == 'Icv Trucks'
        ? 'trucks'
        : 'buses-vans'
    )?.toLowerCase();
    let lob = data.lob?.replace(/\s/g, '-')?.toLowerCase();
    let ppl = data.ppl_seo;
    let pl = data.pl?.replace(/\s/g, '-')?.toLowerCase();
    this.router.navigate([
      '/product-details/' +
        sublob +
        '/' +
        lob +
        '/' +
        ppl +
        '/' +
        pl +
        '/' +
        data.id,
    ]);
  }
  navigateToPLP(val) {
    if (val == 'plp') {
      localStorage.removeItem('totalNoOfRecords')
      localStorage.removeItem('uniqueId')
      localStorage.removeItem('searchValue')
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
      this.router.navigate([`/product-list/${this.lob}`], { queryParams: { is_new_launch: true,"isSearch":true } });
    }
  }

  getExploreBanners(data) {
    this.isLoading = false;
    let lob_data: any = [];
    data?.lob_name.forEach((e) => {
      lob_data.push(
        e
          ?.replace(/\s/g, '-')
          ?.replace(/\---/g, '-')
          ?.replace(/\--/g, '-')
          ?.toLowerCase()
      );
    });

    let req = {
      lob: lob_data,
    };
    try {
      this.sub.add(
        this.apiService.getBannerListNew(req).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            this.centerBanners = response;
            this.isLoading = true;
          },
          error: () => {
            this.spinner.hide();
            this.centerBanners = [];
            this.isLoading = true;
          },
          complete: () => {},
        })
      );
    } catch (error) {}
  }

  exploreBanner() {
    if (isPlatformBrowser(this.platformId)) {
      this.isLoading = true;
      if(this.isMobile){
        this.centerBanners = {
          "cfrnt_url": environment.s3bucket.url,
          ["data"]: [{
            "path": "BannerFiles/ExploreImagesApp/" + this.explore + ".jpg",
            "id": "",
            "banner_link": "",
            "title": ""
          }]
        }
      }else{
      this.centerBanners = {
        "cfrnt_url": environment.s3bucket.url,
        ["data"]: [{
          "path": "BannerFiles/EXPLOREImages/" + this.explore + ".jpg",
          "id": "",
          "banner_link": "",
          "title": ""
        }]
      }
    }
    }
  }

  bookNow(data) {
    if (this.isUserLoggedIn) {
      let sublob =
        data.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : data.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : data.sub_lob?.replace(/\s/g, '-')?.toLowerCase();
      let model = data.model
        ?.replace(/\s/g, '-')
        ?.replace(/\//g, '-')
        ?.replace(/\+/g, '-')
        ?.replace(/\./g, '-')
        ?.toLowerCase();
      this.router.navigate([
        '/lead-booking/' +
          sublob +
          '/' +
          data.lob_seo +
          '/' +
          data.ppl_seo +
          '/' +
          model +
          '/' +
          data.id,
      ]);
    } else {
      let sublob =
        data.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'icv-trucks'
          ? 'trucks'
          : data.sub_lob?.replace(/\s/g, '-')?.toLowerCase() == 'buses'
          ? 'buses-vans'
          : data.sub_lob?.replace(/\s/g, '-')?.toLowerCase();
      let model = data.model
        ?.replace(/\s/g, '-')
        ?.replace(/\//g, '-')
        ?.replace(/\+/g, '-')
        ?.replace(/\./g, '-')
        ?.toLowerCase();
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem(
          'previousUrl',
          '/lead-booking/' +
            sublob +
            '/' +
            data.lob_seo +
            '/' +
            data.ppl_seo +
            '/' +
            model +
            '/' +
            data.id
        );
      }
      this.router.navigate(['/login/']);
    }
    this.clevertapBook(data);
  }
  clevertapBook(productDetailsData: any) {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onBookNowButtonClick(
          productDetailsData['id'],
          productDetailsData['model'],
          productDetailsData['images'][0].image_url,
          'Top Navigation'
        );
      } catch {}
    }
  }
  toggleDescription(value, length) {
    if (value) {
      return value?.length > length ? value.substring(0, length) : value;
    } else {
      return 0;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  onClickNewExplore(data, type) {
    data.categoryType = type;
    if (isPlatformBrowser(this.platformId)) {
      this.localStorage.setItem('ExploreMappedData', JSON.stringify(data));
      localStorage.removeItem('ExploreMappedDatatype');
      localStorage.removeItem('ExploreMappedData1');
      this.localStorage.setItem(
        'ExploreMappedDatatype',
        JSON.stringify(data.categoryType)
      );
    }
    //  let brandType = data.explore_by_type_title
    //   const requestData = {
    //     page: 'BRAND',
    //     brand_type: brandType,
    //     offset: 0,
    //     size: 6,
    //   };
  
      // this.apiService.getBannerData(requestData).subscribe({
      //   next: (res) => {
      //     if (res.success) {
      //       this.router.navigate(['/brand/' + data["explore_by_type_title"].replace(/\s+/g, '-')?.toLowerCase()]);
      //     }
      //     else{
      //       this.router.navigate(['/product-list/' + data["icon"].replace(/\s+/g, '-')?.toLowerCase()]);
      //     }
      //   },
      //   error: (err) => {
      //     console.error('Error fetching banner data', err);
      //    },
      // });
      localStorage.removeItem('sideFilter')
      localStorage.removeItem('totalNoOfRecords')
      localStorage.removeItem('uniqueId')
      localStorage.removeItem('searchValue')
      localStorage.removeItem('filterValue');
      localStorage.removeItem('unbxFilterValue');
      this.behaviorService.filterValue.next('Header')
      this.behaviorService.isUnbxFilterChange.next(false)
      this.behaviorService.isSearch.next(false)
      this.behaviorService.callPlp.next(false)
      this.behaviorService.isClearfilter.next(false);
      // this.router.navigate(['/product-list/' + data["icon"].replace(/\s+/g, '-')?.toLowerCase()]);
      let queryParams:any = {
        "isSearch":true
      }
      let key :any;
      if (type == "Brand") {
        key  = data?.explore_by_brand;
      }
      else
      {
        key  = data?.browse_by_type;
      }
      this.router.navigate(['/product-list/' + key?.replace(/\s+/g, '-')?.toLowerCase()],{ queryParams });

    }

  seo(seoValue: any) {
    let metaTitle =
      'Buy ' +
      this.capitalizeFirstLetter(seoValue) +
      ' Online. Check Price, Features and View Details | Tata Motors';
    let metaDesc =
      'Enquire, Book and Buy ' +
      this.capitalizeFirstLetter(seoValue) +
      ' at fleetverse.tatamotors.com with Tata Motors authorized dealers';
    this.seoservice.updateTitle(metaTitle);
    this.seoservice.updateMetaTag('description', null, metaDesc);
    this.seoservice.updateMetaTag(null, 'og:locale', 'en_US');
    this.seoservice.updateMetaTag(null, 'og:type', 'Website');
    this.seoservice.updateMetaTag(null, 'og:title', metaTitle);
    this.seoservice.updateMetaTag(null, 'og:description', metaDesc);
    this.seoservice.updateMetaTag(null, 'og:site_name', 'Tata OSP');
  }
  capitalizeFirstLetter(str) {
    const arr = str.split(' ');
    for (var i = 0; i < arr?.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    return arr.join(' ');
  }
  // onScrollDiv() {
  //   const box = document.getElementById('brandVideoDiv');
  //   const scrollableHeight = box.scrollHeight - box.clientHeight

  // }
  getPromotionalVideoData(size) {
    if (this.lob) {
      this.categorylisticons = '';
    }
    this.brandVideoSize += size;

    let reqBody: any = {
      offset: 0,
      limit: 10,
      category: 'explore',

      status: 'APPROVED',
    };
    if (this.explore) {
      reqBody.icons = this.categorylisticons
        ? this.categorylisticons.replace(/\s/g, '-')?.toLowerCase()
        : '';
    } else {
      reqBody.lob = this.lob;
    }
    this.showLoader = true;
    this.sub.add(
      this.apiService.getbrandVideosDetail(reqBody).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.videoData = response.data;
            this.videoTotalCount = response.total_count;
            this.videoDetail(this.videoData, response.total_count);
          } else {
            this.videoData = [];
          }
        },
        error: () => {
          this.productLoaded = true;
          this.showLoader = false;
        },
        complete: () => {},
      })
    );
  }

  getVehicleExploreData(lob: any, sharedValue) {
    let sub_lob;
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params.get('sub_lob') == 'trucks') {
        sub_lob = 'trucks';
      } else if (params.get('sub_lob') == 'buses-vans') {
        sub_lob = 'buses';
      } else if (params.get('sub_lob') == 'scv-pickups') {
        sub_lob = 'scv pickups';
      }
    });
    this.categorylisticons = sharedValue?.name;

    let data = {
      vehicle_type: sub_lob ? sub_lob : '',
      lob: lob.replace('-', ' ') ? lob.replace('-', ' ') : '',
      icon: sharedValue?.name
        ? sharedValue?.name.replace('-', ' ')?.toLowerCase()
        : '',
    };

    this.apiService.getVehicleExploreData(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.exploredata = response.data;
          this.localStorage.setItem(
            'exploreData',
            JSON.stringify(this.exploredata)
          );
          this.browseByTypeLoad = true;
          this.browseByModelLoad = true;
          // this.modifiedBrowseByType = response.data.browse_by_title
          // this.modifiedExploreByType = response.data.explore_by_title
          // this.modifiedBrowseByModal = response.data.ppl_data
          this.localStorage.setItem(
            'UrlData',
            JSON.stringify([this.lob, this.sub_lob])
          );
        }
      },
      complete() {
        this.browseByModelLoad = true;
      },
    });
  }

  videoDetail(data: any, count: any) {
    for (var k = 0; k < data?.length; k++) {
      let urls = data[k].path;

      var vthaumbimage = this.youtube_parser(urls);
      let img = 'https://img.youtube.com/vi/' + vthaumbimage + '/mqdefault.jpg';
      let videos = 'https://www.youtube.com/embed/' + vthaumbimage + '';
      this.testSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(videos);
      this.promotionalVideos.push({
        video_url: this.testSafeUrl,
        image_url: img,
      });

      this.promovideosLoaded =
        this.promotionalVideos?.length == count ? true : false;
    }

    setTimeout(() => {
      this.showLoader = false;
      this.productLoaded = true;
    }, 5000);
  }

  youtube_parser(url: any) {
    if (isPlatformBrowser(this.platformId)) {
      var regExp =
        /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
      var match = url.match(regExp);
      return match && match[1]?.length == 11 ? match[1] : false;
    }
  }
  getURL(URL) {
    let url = URL.includes('https://youtu.be/')
      ? URL?.replace('https://youtu.be/', '')
      : URL.includes('https://www.youtube.com/watch?v=')
      ? URL?.replace('https://www.youtube.com/watch?v=', '')
      : URL.includes('https://www.youtube.com/embed/')
      ? URL?.replace('https://www.youtube.com/embed/', '')
      : URL;
    return url;
  }

  getexplorePage() {
    function getUniqueExploreByBrand(objects) {
      const uniqueMap = new Map();

      objects.forEach((obj) => {
        const key = obj.explore_by_brand;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, obj);
        }
      });

      return Array.from(uniqueMap.values());
    }
    function getUniqueExploreBytype(objects) {
      const uniqueMap = new Map();

      objects.forEach((obj) => {
        const key = obj.browse_by_type;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, obj);
        }
      });

      return Array.from(uniqueMap.values());
    }
    function getUniqueExploreByppl(objects) {
      const uniqueMap = new Map();

      objects.forEach((obj) => {
        const key = obj.ppl;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, obj);
        }
      });

      return Array.from(uniqueMap.values());
    }

    function getBrowseByType(data) {
      const browseByTypeArray = [];

      data.forEach((item) => {
        if (item.browse_by_type) {
          // Replace spaces with underscores and add to the array
          browseByTypeArray.push(item.browse_by_type.replace(/\s+/g, '_'));
        }
      });

      return browseByTypeArray;
    }

    try {
      this.exploreVehicleRangeList = [];
      this.newexploreVehicleRangeRESPList = [];


      const data = {
        lob: this.lob ? [this.lob?.replace('-', ' ')?.toLowerCase()] : [], //? [formattedLob] : [],
        ppl: [],
        pl: [],
        level2_actual_name: this.explore
          ? this.explore.replace(/-/g, ' ')?.toLowerCase()
          : '',
        offset: 0,
        limit: 50,
      };

      this.spinner.show();

      this.sub.add(
        this.apiService.explorePage(data).subscribe({
          next: (response: any) => {
            if (response.success) {
              this.spinner.hide();
              this.modifiedBrowseByModal = response.data.explore_page_data;
              this.exploreVehicleRangeList = response.data.explore_page_data;
              this.newexploreVehicleRangeRESPList =
                response.data.explore_page_data;
              // this.uniqueExploreByBrandList = getUniqueExploreByBrand(
              //   this.exploreVehicleRangeList
              // );
              let newdatauniq = getUniqueExploreByBrand(this.exploreVehicleRangeList);
              this.uniqueExploreByBrandList = this.explore === 'bus-chassis' ? [newdatauniq[0]] :newdatauniq;
              this.uniqueExploreBytype = getUniqueExploreBytype(
                this.newexploreVehicleRangeRESPList
              );
              this.uniqueExploreByppl = getUniqueExploreByppl(
                this.modifiedBrowseByModal
              );
              this.imagestype = getBrowseByType(this.modifiedBrowseByModal);
            } else {
              this.exploreVehicleRangeList = [];
              this.toastrService.warning(response.data.msg);
              this.spinner.hide();
            }
          },
          error: (error) => {
            console.error('An error occurred:', error);
            this.spinner.hide();
          },
          complete: () => {},
        })
      );
    } catch (error) {
      console.error('An error occurred:', error);
      this.spinner.hide();
    }
  }
  replaceSpaces(value: string): string {
    if (this.explore == 'passenger-van' && value === 'Van') {
      value = 'Winger-Deluxe';
    } else if (this.explore == 'school-van' && value === 'Van') {
      value = 'Winger-School';
    } else if (this.explore == 'ambulance' && value === 'Van') {
      value = 'Winger-Ambulance';
    } else if (this.explore == 'passenger-van' && value === 'Mini Van') {
      value = 'Magic-Deluxe';
    } else if (this.explore == 'school-van' && value === 'Mini Van') {
      value = 'Magic-School';
    } else if (this.explore == 'ambulance' && value === 'Mini Van') {
      value = 'Magic-Ambulance';
    } else if (this.explore == 'school-bus' && value === 'LCV Buses') {
      value = 'LCV_Buses_school';
    } else if (this.explore == 'school-bus' && value === 'ICV Buses') {
      value = 'ICV_Buses_school';
    }
    return value ? value.replace(/\s+/g, '_') : '';
  }
  replaceSpacesexplore(value: string): string {
    if (this.explore == 'passenger-van' && value === 'WINGER') {
      value = 'Winger-Deluxe';
    } else if (this.explore == 'school-van' && value === 'WINGER') {
      value = 'Winger-School';
    } else if (this.explore == 'ambulance' && value === 'WINGER') {
      value = 'Winger-Ambulance';
    } else if (this.explore == 'passenger-van' && value === 'MAGIC') {
      value = 'Magic-Deluxe';
    } else if (this.explore == 'school-van' && value === 'MAGIC') {
      value = 'Magic-School';
    } else if (this.explore == 'ambulance' && value === 'MAGIC') {
      value = 'Magic-Ambulance';
    } else if (this.explore == 'school-bus' && value === 'STARBUS PRIME') {
      value = 'Starbus_prime_school';
    } else if (this.explore == 'school-bus' && value === 'CITYRIDE') {
      value = 'cityride_school';
    } else if (this.explore == 'school-bus' && value === 'ULTRA PRIME') {
      value = 'Ultra_prime_school';
    } else if (this.explore == 'school-bus' && value === 'ULTRA') {
      value = 'Ultra_school';
    } else if (this.explore == 'school-bus' && value === 'STARBUS ULTRA') {
      value = 'STARBUS_ULTRA_SCHOOL';
    } else if (this.explore == 'school-bus' && value === 'STARBUS') {
      value = 'STARBUS_SCHOOL';
    } else if (this.explore == 'school-bus' && value === 'CITYRIDE PRIME') {
      value = 'CITYRIDE_PRIME_SCHOOL';
    } else if (
      (this.explore == 'intercity-bus' ||
        this.explore == 'bus-chassis' ||
        this.explore == 'staff-bus') &&
      value === 'ULTRA'
    ) {
      value = 'ULTRA_BUS';
    }

    return value ? value.replace(/\s+/g, '_') : '';
  }
  replaceSlashAndDot(value: string): string {
    if (this.explore == 'passenger-van' && value === 'Winger') {
      value = 'Winger-Deluxe';
    } else if (this.explore == 'school-van' && value === 'Winger') {
      value = 'Winger-School';
    } else if (this.explore == 'ambulance' && value === 'Winger') {
      value = 'Winger-Ambulance';
    } else if (this.explore == 'passenger-van' && value === 'Magic') {
      value = 'Magic-Deluxe';
    } else if (this.explore == 'school-van' && value === 'Magic') {
      value = 'Magic-School';
    } else if (this.explore == 'ambulance' && value === 'Magic') {
      value = 'Magic-Ambulance';
    }
    return value ? value.replace(/[\/.]/g, '_') : '';
  }

updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
  if (!isPlatformBrowser(this.platformId)) {
    return imageUrl;
  }

  if (!imageUrl) {
    return '';
  }

  if (!element) {
    return imageUrl;
  }

  try {
    // Get actual width & height of the card
    const actualWidth = width && width > 0 ? width : element.clientWidth || 300;  // Default to 300 if no width
    const actualHeight = height && height > 0 ? height : element.clientHeight || 200;  // Default to 200 if no height
  


    const imgWidth = Math.floor(actualWidth * 0.8);
    const imgHeight = Math.floor((imgWidth / 100) * 67);
  
  

    // Ensure the URL is properly formatted
    const baseUrl = imageUrl.split('/resize/')[0];  // Get the base URL without resize parameters
    if (!baseUrl) {
      return imageUrl;
    }

    const updatedUrl = `${baseUrl}/resize/${imgWidth}x${imgHeight}`;
  


    return updatedUrl;
  } catch (error) {
    return imageUrl;  // Return original URL if there's an error
  }
}
}
